import {
  stateLoaders,
  type CountryCode,
} from '@resideo/blueprint-react/dist/generated/stateLoaders';

export type State = {
  iso2: string;
  name: string;
};

export const getStates = async (
  countryCode: string
): Promise<readonly State[]> => {
  if (!Object.hasOwn(stateLoaders, countryCode)) return [];
  try {
    const mod = await stateLoaders[countryCode as CountryCode]();
    return mod.default;
  } catch {
    return [];
  }
};

export const getStateName = async (
  countryCode: string,
  stateCode: string
): Promise<string> => {
  const states = await getStates(countryCode);
  return states.find(s => s.iso2 === stateCode)?.name ?? '';
};
